import React from 'react';
import { useAuth } from '../context/AuthContext';
import {
  VStack,
  Card,
  CardHeader,
  CardBody,
  Text,
  Badge,
  SimpleGrid,
  useColorModeValue,
  Heading,
  Avatar,
  Flex,
  Box,
} from '@chakra-ui/react';
import { motion } from 'framer-motion';
import PageLayout from '../components/PageLayout';

const MotionCard = motion(Card);

const AdminList = () => {
  const { currentUser } = useAuth();
  const cardBg = useColorModeValue('white', 'gray.700');

  // Dummy data for admins
  const admins = [
    {
      id: 1,
      name: 'John Doe',
      role: 'superadmin',
      email: 'john@example.com',
      lastActive: '2024-03-20T10:30:00',
      status: 'active',
    },
    {
      id: 2,
      name: 'Jane Smith',
      role: 'admin',
      email: 'jane@example.com',
      lastActive: '2024-03-19T15:45:00',
      status: 'active',
    },
    // Add more dummy admins as needed
  ];

  return (
    <PageLayout title="Administrators">
      <VStack spacing={6} w="100%" maxW="1200px" mx="auto">
        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6} w="100%">
          {admins.map((admin) => (
            <MotionCard 
              key={admin.id} 
              whileHover={{ scale: 1.02 }} 
              bg={cardBg}
              boxShadow="lg"
            >
              <CardHeader>
                <Flex align="center" gap={4}>
                  <Avatar name={admin.name} />
                  <Box>
                    <Heading size="sm">{admin.name}</Heading>
                    <Badge 
                      colorScheme={admin.role === 'superadmin' ? 'green' : 'purple'}
                      mt={1}
                    >
                      {admin.role}
                    </Badge>
                  </Box>
                </Flex>
              </CardHeader>
              <CardBody>
                <VStack align="start" spacing={2}>
                  <Text fontSize="sm" color="gray.500">
                    Email: {admin.email}
                  </Text>
                  <Text fontSize="sm" color="gray.500">
                    Last Active: {new Date(admin.lastActive).toLocaleString()}
                  </Text>
                  <Badge 
                    colorScheme={admin.status === 'active' ? 'green' : 'red'}
                    mt={2}
                  >
                    {admin.status}
                  </Badge>
                </VStack>
              </CardBody>
            </MotionCard>
          ))}
        </SimpleGrid>
      </VStack>
    </PageLayout>
  );
};

export default AdminList; 